@if (alertInfo.show) {
  <ngb-alert
    [type]="alertInfo.type"
    (closed)="alertInfo.show = false"
    >
    {{ alertInfo.message }}
  </ngb-alert>
}
@if (this.proposal?.status) {
  <form [formGroup]="form">
    <div class="row g-3">
      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-2 minw-field date-field mt-2">
        <input-field
          type="date"
          [inputFormControl]="getProposalDateInput()"
          [readonly]="true"
          label="Date"
          placeholder="Date"
          />
      </div>
      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-4 mt-2">
        <input-field
          type="text"
          [inputFormControl]="getProposalCategoryInput()"
          [readonly]="true"
          label="Category"
          placeholder="Category"
          />
      </div>
      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-2 minw-field time-field mt-2">
        <input-field
          type="time"
          [inputFormControl]="getProposalProjectTimeInput()"
          [readonly]="readonlyProposalData"
          label="Project Time"
          placeholder="Project Time"
          />
      </div>
      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-2 mt-2 proposal-steps-container">
        <select-field [selectFormControl]="getProposalProposalStepsInput()"
          [readonly]="readonlyProposalData"
          [options]="proposalsSteps"
          label="Proposal Steps"/>
      </div>
      <div class="col-sm-4 col-md-4 col-lg-5 col-xl-3 mt-2">
        <select-field [selectFormControl]="getProposalProposalModelInput()"
          [readonly]="readonlyProposalData"
          [options]="proposalsModels"
          label="Proposal Model"/>
      </div>
      @if (showPlaceOfSign()) {
        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-2">
          <input-field
            type="text"
            [inputFormControl]="getProposalPlaceOfSignInput()"
            [readonly]="readonlyProposalData"
            label="Place of Sign"
            placeholder="Place of Sign"/>
        </div>
      }
      @if (showManufactorerFields()) {
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-2">
          <input-field
            type="text"
            [inputFormControl]="getManufactorerCompanyNameInput()"
            [readonly]="readonlyProposalData"
            label="Manufactorer Company Name"
            placeholder="Manufactorer Company Name"/>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-2">
          <input-field
            type="text"
            [inputFormControl]="getManufactorerAddressInput()"
            [readonly]="readonlyProposalData"
            label="Manufactorer Address"
            placeholder="Manufactorer Address"/>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-2">
          <input-field
            type="text"
            [inputFormControl]="getManufactorerContactPersonInput()"
            [readonly]="readonlyProposalData"
            label="Manufactorer Contact Person"
            placeholder="Manufactorer Contact Person"/>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-2">
          <input-field
            type="text"
            [inputFormControl]="getManufactorerEmailAddressInput()"
            [readonly]="readonlyProposalData"
            label="Manufactorer Email Address"
            placeholder="Manufactorer Email Address"/>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-2">
          <input-field
            type="text"
            [inputFormControl]="getManufactorerVatNumberInput()"
            [readonly]="readonlyProposalData"
            label="Manufactorer VAT Number"
            placeholder="Manufactorer VAT Number"/>
        </div>
      }
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-2 payment-company-container">
        <select-field [selectFormControl]="getProposalPaymentCompanyInput()"
          [options]="getPaymentCompanyOptions()"
          [readonly]="readonlyProposalData"
          label="Payment Company"/>
      </div>
      <div class="col-12 mt-2">
        <proposals-payment-condition
          [readonlyPaymentCondition]="readonlyProposalData"
          [paymentCondition]="proposal?.proposalPaymentConditions"
          (paymentConditionsChange)="updateProposalPaymentConditions($event)"/>
      </div>
      <div class="col-sm-6 mt-2">
        <select-field [selectFormControl]="getProposalPaymentMethodInput()"
          [readonly]="readonlyProposalData"
          [options]="paymentMethods"
          label="Payment Method"/>
      </div>
      <div class="col-sm-6 mt-2">
        <input-field
          type="date"
          [inputFormControl]="getProposalDateSentOnInput()"
          [readonly]="readonlyProposalData"
          [label]="proposal?.data?.sentOn === true ? 'This proposal has been sent on' : 'This proposal has not been sent'"
          />
      </div>
      <div class="col-sm-6 mt-2">
        <input-field
          type="datetime-local"
          [inputFormControl]="getProposalDateReminderInput()"
          [readonly]="readonlyProposalData"
          label="Set push reminder"
          placeholder="Set push reminder"
          />
      </div>
      <div class="col-sm-6 mt-2">
        <div class="form-group">
          <label class="fw-bold py-2">{{proposal?.data?.sentOn === true ? 'This proposal has to be checked' : 'This proposal has been checked' }}</label>
        </div>
        <!-- <input-field
        type="text"
        [inputFormControl]="getProposalCheckedInput()"
        label="This proposal has to be checked"
        [label]=""
        /> -->
      </div>     
      <div class="col-sm-6 mt-2">
        <select-field [selectFormControl]="getTargetCurrencyIdInput()"
          [readonly]="readonlyProposalData"
          [options]="currenciesOptions"
          label="Target Currency"/>
      </div>
      <div class="col-sm-6 mt-2">
        <input-field
          type="number"
          [inputFormControl]="getTargetExchangeRateInput()"
          [readonly]="readonlyProposalData"
          label="Target Exchange Rate"
          placeholder="Target Exchange Rate"/>
      </div>
    </div>
  </form>
}
